module.exports = __webpack_public_path__ + "assets/images/01-active_f3058632b35e69a16d1c4b1644e95ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-4/01-active.png
// module id = 249
// module chunks = 0